import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}><path d="M268.8 211.2h134.4c24.7 0 44.8 20.1 44.8 44.8s-20.1 44.8-44.8 44.8H44.8C20.1 300.8 0 280.7 0 256s20.1-44.8 44.8-44.8h134.4z" /></svg>);